/**
 * Frontend-Konfiguration (keine App-Passwörter — Login serverseitig api/auth.php + config/shopware.php).
 */

export const appConfig = {
  /**
   * Artikelsuche: POST zum PHP-Proxy (Session-Cookie mitsenden).
   */
  shopware: {
    proxyPath: 'api/product-by-gtin.php',
    timeoutMs: 20000,
  },
};

export default appConfig;
